/** TRUS-820: a cluster figure for display. Missing data is a dash, never 0. */
export function formatClusterNumber(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return Math.round(v).toLocaleString();
}
